import { get, post } from "./utilities/http";
import { CANCELLATION, REASONS } from "./utilities/app.urls";
import { ICancellationReasonDto } from "../common/interfaces/club-application.interface";
import { CancellationType } from "../common/enums/proposals.enums";

export function getCancellationReasons(cancellationType: CancellationType) {
  return get(`${CANCELLATION}/${REASONS}/${cancellationType.toString()}`);
}

/**
 *
 * @param cancellationReason Dto containing data about proposal that is cancelled
 * @returns
 */
export function saveCancellationReason(
  cancellationReason: ICancellationReasonDto
) {
  return post(CANCELLATION, cancellationReason);
}

/**
 *
 * @param proposalAddress Address of proposal to cancel
 * @returns
 */
export function getCancellationReasonForProposal(proposalAddress: string) {
  return get(`${CANCELLATION}/${proposalAddress}`);
}
